import { useGetDisplayStylesParams } from 'root/hooks/useGetDisplayStylesParams';
import { useGetDisplaySettingsParams } from 'root/hooks/useGetDisplaySettingsParams';
import { useItemsContext } from 'root/contexts/ItemsContext';
import { useGetHtmlTag } from 'root/hooks/useGetHtmlTag';
import type { Modifier } from 'root/apiTypes';
import { isPriceShowed, isSectionChecked } from 'root/utils/display';
import type { MenuCheckbox } from 'root/clientTypes';
import { useExperiments } from '@wix/yoshi-flow-editor';

export const useModifierLogic = ({ modifier }: { modifier: Modifier }) => {
  const { sectionId } = useItemsContext();

  const { showModifierCurrency } = useGetDisplayStylesParams();
  const { showZeroPrice, checkPricingMenus, showZeroPriceToAll, showModifierIcon } = useGetDisplaySettingsParams();

  const modifierTitleHtmlTag = useGetHtmlTag('modifierTheme');

  const formattedPrice = showModifierCurrency
    ? modifier.additionalChargeInfo?.formattedAdditionalCharge
    : modifier.additionalChargeInfo?.additionalCharge ?? '';
  const priceOptionSectionChecked =
    showZeroPriceToAll || isSectionChecked(checkPricingMenus as MenuCheckbox[], sectionId ?? '');

  const shouldShowModifiersPrice = isPriceShowed({
    price: modifier.additionalChargeInfo?.additionalCharge ?? '',
    showZeroPrice: showZeroPrice as boolean,
    sectionChecked: priceOptionSectionChecked as boolean,
  });

  const { experiments } = useExperiments();
  const isIconExperimentEnabled = experiments.enabled('specs.restaurants.menus.ooi.modifiers.icon');
  const shouldShowModifiersIcon = !isIconExperimentEnabled || showModifierIcon;

  return {
    formattedPrice,
    shouldShowModifiersPrice,
    modifierTitleHtmlTag,
    shouldShowModifiersIcon,
  };
};
